import type { INotification } from '@/interfaces';
import { HubsService, UserService } from '@/services';
import { UserStore } from '@/stores';
import { Colors, Icons, Routes } from '@/utils';
import { NBadge, NButton, NIcon } from 'naive-ui';
import { computed, defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { AppButtonIcon } from './AppButtonIcon';

export const AppUserNotification = defineComponent({
	name: 'AppUserNotification',
	setup() {
		const router = useRouter();
		const userStore = UserStore();

		userStore.initNofiicationsHub();

		const hasUnreadNotification = computed(() =>
			userStore.notifications.some((x) => x.readAt == null),
		);

		return () => (
			<NBadge dot processing show={hasUnreadNotification.value}>
				<AppButtonIcon
					icon={Icons.Notification}
					onClick={() => router.push({ name: Routes.NotificationsView })}
					tooltipMessage="Notificações"
				/>
			</NBadge>
		);
	},
});
